import { render, staticRenderFns } from "./lkuCrewlazzy.vue?vue&type=template&id=58e4876c"
import script from "./lkuCrewlazzy.vue?vue&type=script&lang=js"
export * from "./lkuCrewlazzy.vue?vue&type=script&lang=js"
import style0 from "./lkuCrewlazzy.vue?vue&type=style&index=0&id=58e4876c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports